import { createContext, useContext, useState } from 'react';

const Context = createContext({});

const UnregisteredExitContextProvider = ({ children }) => {
    const [paramsContext, setParamsContext] = useState(null);

    return <Context.Provider value={{ paramsContext, setParamsContext }}>{children}</Context.Provider>;
};

const useUnregisteredExitContextProvider = () => {
    return useContext(Context);
};

export { UnregisteredExitContextProvider, useUnregisteredExitContextProvider };
